export default { UNLIMITED: -1 };
